<template>
    <transition name="move" mode="out-in">
        <router-view>
        </router-view>
    </transition>
</template>

<script>
import 'animate.css';
export default {
    name: 'Right',

}
</script>

<style></style>